import { Box, Skeleton, Stack } from '@mui/material'
import { FC } from 'react'
import { SkeletonText } from 'utoniq-ui'

type ReplyBoxSkeletonProps = {
  divider?: boolean
}

export const ReplyBoxSkeleton: FC<ReplyBoxSkeletonProps> = ({ divider }) => (
  <>
    <Stack flex={1} direction="row" spacing={2} sx={{ pb: 1 }}>
      <Box>
        <Skeleton variant="circular" width={28} height={28} />
      </Box>
      <Stack flex={1}>
        <Stack direction="row" justifyContent="space-between">
          <SkeletonText variant="small" width="25%" />
        </Stack>
        <Box sx={{ pt: 2 }}>
          <SkeletonText variant="medium" numberOfLine={3} lastWidth="75%" />
        </Box>
        <Box sx={{ pt: 4 }}>
          <SkeletonText variant="small" width="25%" />
        </Box>
      </Stack>
    </Stack>
    {divider && <Skeleton variant="rectangular" width="100%" height={1} />}
  </>
)
